<div class="anc-summary-list">
    <div class="anc-summary-list__title" *ngIf="title()">{{ title() }}</div>
    <div class="anc-summary-list__body">
        <ng-content></ng-content>
    </div>
</div>
